export default __webpack_public_path__ + "static/media/journalIntro.e3b2bf88.png";